/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HeaderSection from "../../common/headerSection";
import PageHeader from "../../common/pageHeader";
import { userService } from "../../../service/plateServices";
import moment from "moment";
import CustomToast from "../../../widgets/toaster";
import { columns, columnsHistory } from './partials/columns';
import Requests from "./partials/requests";
import History from "./partials/history";
import AddException from "../../common/addException";
import AddDeviationModel from "../../common/addDeviation";
import { DEFAULT_PAGE_SIZE } from "../../../constants/constants";
import { scheduleService } from "../../../service/scheduleService";
import { helperFunctions } from "../../../utils/helper";
import AddExceptionModal from "../../common/addException/addException";


const ExceptionHandling = () => {
  const [tab, setTab] = useState("1");
  const [show, setShow] = useState(false);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [userId, setUserId] = useState<number>(0);
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState("success")
  const [toastType, setToastType] = useState("success")
  const [authToken, setAuthToken] = useState("")
  const [authUserID, setAuthUserID] = useState("")

  //pagination
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)
  //Exception listing
  const [plateDetails, setPlateDetails] = useState<Array<any>>([]);
  const [plateStatus, setPlateStatus] = useState("16")
  const [plateSerielNum, setPlateSerielNums] = useState([])
  const [keyWord, setkeyWord] = useState("")

  //pagination in Exception History Area
  const [pageHistory, setPageHistory] = useState(1)
  const [pageSizeHistory, setPageSizeHistory] = useState(DEFAULT_PAGE_SIZE)
  const [totalPagesHistory, setTotalPagesHistory] = useState(0)
  const [totalElementsHistory, setTotalElementsHistory] = useState(0)
  //Exception History
  const [plateDetailsHistory, setPlateDetailsHistory] = useState<Array<any>>([]);
  const [plateStatusHistory, setPlateStatusHistory] = useState("")
  const [keyWordHistory, setkeyWordHistory] = useState("")
  const [reasonId, setReasonId] = useState("");
  const [historyReasonId, setHistoryReasonId] = useState("");
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [scheduleProductId, setScheduleProductId] = useState("");
  const [productId, setProductId] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [scheduleProductIdHistory, setScheduleProductIdHistory] = useState("");
  const [productIdHistory, setProductIdHistory] = useState("");
  const sortRemovelist=["date","status","slno","location_name"]
  const sortRemovelistHistory=["slno","approved_by","approved_on","status","location_name"]


  const { t } = useTranslation();

  //get user details
  useEffect(() => {
    var storedData = localStorage.getItem('userDetails');

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id)
      setAuthToken(storedObject[0].x_auth_token)
      setAuthUserID(storedObject[0].x_userid)
    }

    //getExceptionPlates();
    //getExceptionPlateHistory();
    listSerialNumber();
    getProductionSchedules();
    getProductList();

    //setUseEffectRequired(false)
  }, [])


  // Load exception requests when tab is "1" (Requests)
  useEffect(() => {
    if (tab === "1") {
      getExceptionPlates();
      setUseEffectRequired(false)
    }
  }, [tab, page, pageSize, sort, order, plateStatus, keyWord, reasonId, scheduleProductId, productId, keyWord,serialNumber, useEffectRequired]);

  // Load exception history when tab is "2" (History)
  useEffect(() => {
    if (tab === "2") {
      getExceptionPlateHistory();
    }
  }, [tab,pageHistory, pageSizeHistory, sort, order, plateStatusHistory, keyWordHistory, historyReasonId, scheduleProductIdHistory, productIdHistory, 
      useEffectRequired]);

  //api call to list exception plate detail in request tab 
  const getExceptionPlates = async () => {
    try {
      const response = await userService.getExceptionPlates(page, pageSize, sort, order, plateStatus, keyWord, reasonId, authToken, authUserID, scheduleProductId, productId, serialNumber);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPages(response?.totalPages)
            setTotalElements(response?.totalElements)
            let rowData: any = response.data.map((element: any, index: number) => {
                
              const statusNumber = parseInt(element.status, 10);
              let status = userService.getPlateStatus(statusNumber);

              // Function to get incubation order suffix
              const getOrdinalSuffix = (num: number): string => {
                  if (num % 100 >= 11 && num % 100 <= 13) return "th"; // general approach for higher than two digits
                  switch (num % 10) {
                      case 1: return "st";
                      case 2: return "nd";
                      case 3: return "rd";
                      default: return "th";
                  }
              };

              if ((statusNumber === 12 || statusNumber === 13) && element.incubation_counter > 0) {
                  const suffix = getOrdinalSuffix(element.incubation_counter);
                  status = `${element.incubation_counter}${suffix} ${status}`;
              } 

              const datetimeParts = element.exception_requested_datetime
              const datePart = moment(datetimeParts).format('YYYY-MM-DD');
              const requestUser = `${element.exception_requested_user_firstname} ${element.exception_requested_user_lastname}`;
              return {
                ID: "EX_" + element.id,
                production_schedule_name: element.production_schedule_name || '-',
                product_name: element.product_name || '-',
                batch_number: element.batch_number || '-',
                serial_number: element.serial_number || '-',
                reason: element.reason,
                slno: index + 1,
                date: helperFunctions.formatDate(element.exception_requested_datetime, true),
                area_name: element.area_name || '-',
                location_name: element.location_name || '-',
                exception_requested_user_firstname: requestUser,
                exception_requested_by: element.requested_user_login_id,
                status: status,
                id: element.id
              };
            });
            setPlateDetails(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setPlateDetails([])
        setTotalPages(0)
        setTotalElements(0)
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  };

  //api call to list exception plate detail in history tab 
  const getExceptionPlateHistory = async () => {
    try {
      const response = await userService.getExceptionPlateHistory(pageHistory, pageSizeHistory, sort, order, plateStatusHistory, keyWordHistory, historyReasonId, authToken, authUserID, scheduleProductIdHistory, productIdHistory);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPagesHistory(response?.totalPages)
            setTotalElementsHistory(response?.totalElements)
            let rowData: any = response.data.map((element: any, index: number) => {

              const statusNumber = parseInt(element.status, 10);
              if (statusNumber == 17) {
                var status = "Approved"
              } else if (statusNumber == 19) {
                var status = "Rejected"
              } else {
                var status = "Unknown status"
              }

              const datetimeParts = element.approved_datetime;
              let approvedDate = null;

              if (datetimeParts !== null) {
                const approvedDatePart = moment(datetimeParts).format('DD-MM-YYYY');
                approvedDate = approvedDatePart;
              }
              const requestUser = `${element.exception_requested_user_firstname} ${element.exception_requested_user_lastname}`;

              let approvedUser = null;
              if (element.approver_firstname !== null && element.approver_lastname !== null) {
                approvedUser = `${element.approver_firstname} ${element.approver_lastname}`;
              }

              return {
                slno: "EX_" + element.id,
                production_schedule_name: element.production_schedule_name || '-',
                product_name: element.product_name || '-',
                batch_number: element.batch_number,
                serial_number: element.serial_number,
                reason: element.reason,
                area_name: element.area_name || '-',
                location_name: element.location_name || '-',
                operator_name: requestUser,
                exception_requested_by: element.requested_user_login_id,
                approved_by: approvedUser || '-',
                approved_on: approvedDate || '-',
                status: status,
              };
            });
            setPlateDetailsHistory(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setPlateDetailsHistory([])
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  };

  //api call to list the serial number for filter dropdown 
  const listSerialNumber = async () => {
    try {
      const response = await userService.listSerialNumber();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {

              return {
                value: element.serial_number,
                label: element.serial_number,
              };
            });
            setPlateSerielNums(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

   // get ProductionScheduleList
  const getProductionSchedules = async () => {
    try {
      const response = await scheduleService.getProductionSchedules();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // handle on approve button click 
  const handleApproveClick = async (selectedRows: string[]) => {
    const filteredPlateDetails = plateDetails.filter((item) => selectedRows.includes(item.slno));
    const selectedIds = filteredPlateDetails.map((item) => item.id).join(',');

    const dataToSend = {
      "exception_ids": selectedIds,
      "user_id": userId,
      "status": "17",
      "interface_name": "Approve Exception"
    }

    try {
      const response = await userService.changeExceptionStatus(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastType("success")
        setToastMessage(response.message)
      } else {
        setToastType("error")
        setToastMessage(response.message)
      }
      setShowToast(true)
      setUseEffectRequired(true)
      getExceptionPlateHistory();
    } catch (error) {
      console.error(error);
    }
  }

  // handle on reject button click in request tab 
  const handleRejectClick = async (selectedRows: string[]) => {
    const filteredPlateDetails = plateDetails.filter((item) => selectedRows.includes(item.slno));
    const selectedIds = filteredPlateDetails.map((item) => item.id).join(',');

    const dataToSend = {
      "exception_ids": selectedIds,
      "user_id": userId,
      "status": "19",
      "interface_name": "Reject Exception"
    }

    try {
      const response = await userService.changeExceptionStatus(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastType("success")
        setToastMessage(response.message)
      } else {
        setToastType("error")
        setToastMessage(response.message)
      }
      setShowToast(true)
      setUseEffectRequired(true)
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //handle table pagination in request view table 
  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPage(newPage);
    if (pageSize) {
      setPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

  //handle table pagination in history view table 
  const handleHistoryPageChange = (newPage: any, pageSize?: number) => {
    setPageHistory(newPage);
    if (pageSize) {
      setPageSizeHistory(pageSize)
    }
    setUseEffectRequired(true)
  };

  //handle filter in request table section 
  const handleFilter = (key: string, value: any) => {
    if (key === "ExceptionReason") {
      setReasonId(value)
    }
    if (key === "search") {
      setkeyWord(value)
    } else if (key === "productionSchedule") {
      setScheduleProductId(value)
    } else if (key === "productName") {
      setProductId(value)
    } else if (key === "serial_number") {
      setSerialNumber(value)
    }
    setUseEffectRequired(true)
  }

  // handle filter in history view table 
  const handleHistoryFilter = (key: string, value: any) => {
    if (key === "ExceptionReason") {
      setHistoryReasonId(value)
    }
    if (key === "search") {
      setkeyWordHistory(value)
    } else if (key === "productionSchedule") {
      setScheduleProductIdHistory(value)
    } else if (key === "productName") {
      setProductIdHistory(value)
    }
    setUseEffectRequired(true)
  }

  // function to sort table
  const handleSortHistory = (key: string, value: boolean) => {
    setSort(key)
    if (value) {
      setOrder("asc")
    } else {
      setOrder("desc")
    }
    setUseEffectRequired(true)
  }

  // function to sort table
  const handleSort = (key: string, value: boolean) => {
    setSort(key)
    if (value) {
      setOrder("asc")
    } else {
      setOrder("desc")
    }
    setUseEffectRequired(true)
  }

  // Handle tab change to reset filters when switching tabs
  const handleTabChange = (newTab: string) => {
    setTab(newTab);
    
    if (newTab === "1") {
      // Reset request tab states
      setPage(1);
      setPageSize(DEFAULT_PAGE_SIZE);
    setSort("id");
    setOrder("desc");
    // Reset request filters
    setScheduleProductId("");
    setProductId("");
    setReasonId("");
    setkeyWord("");
    } else if (newTab === "2") {
      // Reset history tab states
    setPageHistory(1);
    setPageSizeHistory(DEFAULT_PAGE_SIZE);
    setSort("id");
    setOrder("desc");
    // Reset history filters
    setkeyWordHistory("");
    setHistoryReasonId("");
    setScheduleProductIdHistory("");
    setProductIdHistory("");
    }
  };


  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t('exceptionHandling.title')} pageDescription={t('pageDescription.exceptionHandling.description')} />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      <div className="exceptionHandlingTab">
        <button
          // onClick={() => setTab("1")}
          onClick={() => handleTabChange("1")}
          className={tab === "1" ? "colTabBtnSel" : "colTabBtn"}
        >
          {t('exceptionHandling.request')}
        </button>
        <button
          // onClick={() => setTab("2")}
          onClick={() => handleTabChange("2")}
          className={tab === "2" ? "colTabBtnSel" : "colTabBtn"}
        >
          {t('exceptionHandling.history')}
        </button>
      </div>

      {tab === "1" && (
        <Requests
          plateDetails={plateDetails}
          prodScheduleList={prodScheduleList}
          productList={productList}
          columns={columns}
          plateSerielNum={plateSerielNum}
          totalElements={totalElements}
          page={page}
          totalPages={totalPages}
          handleApproveClick={handleApproveClick}
          handleRejectClick={handleRejectClick}
          handleAddClick={() => setShow(true)}
          handlePageChange={handlePageChange}
          handleFilter={handleFilter}
          handleSort={handleSort}
          sortRemovelist={sortRemovelist}
        />
      )}

      {tab === "2" && (
        <History
          plateDetailsHistory={plateDetailsHistory}
          prodScheduleList={prodScheduleList}
          productList={productList}
          columnsHistory={columnsHistory}
          totalElementsHistory={totalElementsHistory}
          pageHistory={pageHistory}
          totalPagesHistory={totalPagesHistory}
          handleHistoryPageChange={handleHistoryPageChange}
          handleFilter={handleHistoryFilter}
          handleSort={handleSortHistory}
          sortRemovelistHistory={sortRemovelistHistory}
        />
      )}

      {/* add exception modal */}
      <AddExceptionModal showModel={show} setShowModel={() => setShow(false)} setRefreshPage={() => setUseEffectRequired(true)} />
      {/* <AddDeviationModel show={show} setShow={() => setShow(false)} /> */}

    </div>
  );
};

export default ExceptionHandling;
